<template>
  <div class="layout-form">
    <joi-form :data="data" :schema="validationSchema" :error="formError" v-on:formdataready="save">
      <div class="row">
        <div class="small-4 columns small-centered">
          <span data-form-error-callout></span>
        </div>
      </div>

      <div class="row expanded">
        <div class="small-12 medium-4 columns">
          <label>
            Név:
            <input type="text" name="displayName" v-model="data.displayName">
          </label>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-12 medium-4 columns">
          <label>
            E-mail:
            <input type="text" name="email" v-model="data.email">
          </label>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-12 columns">
          <label>
            Hozzáférés:
          </label>
          <input id="accessGranted-yes" type="radio" :value="true" v-model="data.accessGranted"><label for="accessGranted-yes">Engedélyezve</label>
          <input id="accessGranted-no" type="radio" :value="false" v-model="data.accessGranted"><label for="accessGranted-no">Tiltva</label>
          <span error-path="accessGranted"></span>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-12 columns">
          <label>
            Szerepkör:
          </label>
          <input id="role-user" type="radio" value="user" v-model="data.role"><label for="role-user">Vendég</label>
          <input id="role-admin" type="radio" value="admin" v-model="data.role"><label for="role-admin">Admin</label>
          <span error-path="role"></span>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-12 medium-4 columns">
          <label>
            Jelszó:
            <input type="password" name="password" v-model="data.password">
          </label>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-12 medium-4 columns">
          <label>
            Jelszó még egyszer:
            <input type="password" name="passwordCheck" v-model="data.passwordCheck">
          </label>
        </div>
      </div>
      <div class="row expanded bottom">
        <div class="small-4 columns">
          <button type="submit" class="button primary trans-uppercase">Mentés</button>
          <button type="button" class="button alert trans-uppercase" v-if="data.id" @click="remove">Törlés</button>
          <button type="button" class="button secondary trans-uppercase" @click="back">Vissza</button>
        </div>
      </div>
    </joi-form>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import * as mutationTypes from '../../store/mutation-types'
import JoiForm from '../../inputs/joi-form'
import {editUser as validationSchema} from '../../../schemas'
import Confirm from '../../mixins/Confirm'
import userService from '../../services/user'

export default {
  name: 'users-edit',
  mixins: [Confirm],
  components: {
    JoiForm
  },
  data () {
    return {
      data: {
        id: '',
        displayName: '',
        email: '',
        password: '',
        passwordCheck: '',
        role: '',
        accessGranted: ''
      },
      validationSchema,
      formError: null,
      existingUser: false,
      lastReadingInf: null
    }
  },
  created: function () {
    if (this.$route.params.id) {
      this.load(this.$route.params.id)
    }
  },
  mounted: function () {
  },
  watch: {
    '$route': function (newVal, oldVal) {
      if (newVal.params.id) {
        this.load(newVal.params.id)
      }
    }
  },
  methods: {
    ...mapMutations([mutationTypes.BUSY_ON, mutationTypes.BUSY_OFF]),
    back () {
      this.$router.push({name: 'user-list'})
    },
    load (id) {
      this.reset()
      this[mutationTypes.BUSY_ON]()
      userService.load(id).then((data) => {
        this[mutationTypes.BUSY_OFF]()
        this.data = data
        this.data.password = ''
      })
      .catch(() => {
        this[mutationTypes.BUSY_OFF]()
      })
    },
    reset () {
    },
    save (formData) {
      this[mutationTypes.BUSY_ON]()
      userService.save(this.data.id, formData).then((result) => {
        this[mutationTypes.BUSY_OFF]()
        this.back()
      }).catch((err) => {
        this[mutationTypes.BUSY_OFF]()
        this.formError = err
      })
    },
    remove () {
      this.confirm('Törlés', 'Biztos vagy benne?').then((confirmed) => {
        if (confirmed) {
          this[mutationTypes.BUSY_ON]()
          userService.remove(this.data.id).then((result) => {
            this[mutationTypes.BUSY_OFF]()
            this.back()
          }).catch((err) => {
            this[mutationTypes.BUSY_OFF]()
            this.formError = err
          })
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../../../sass/foundation-import';
  @import '../../../sass/layouts/form';
</style>



// WEBPACK FOOTER //
// Edit.vue?73dd190b